var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatR(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".subject-mat-r-1{fill:#464af0;}.subject-mat-r-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Matematyka") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4078",
    "data-name": "Group 4078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_16",
    "data-name": "Line 16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-mat-r-2",
    d: "M42.09,26.12H8.65a.75.75,0,0,1,0-1.5H42.09a.75.75,0,0,1,0,1.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4070",
    "data-name": "Group 4070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_3407",
    "data-name": "Path 3407"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-mat-r-2",
    d: "M36.52,32.71c-1.7,0-2.38-3.37-3.16-7.27-.59-3-1.33-6.66-2.42-6.66s-1.82,3.69-2.42,6.66c-.78,3.9-1.45,7.27-3.15,7.27S23,29.34,22.21,25.44c-.59-3-1.33-6.66-2.42-6.66s-1.82,3.7-2.42,6.67c-.78,3.9-1.45,7.26-3.15,7.26s-2.37-3.36-3.15-7.27c-.59-3-1.33-6.66-2.42-6.66a.38.38,0,0,1,0-.75c1.7,0,2.37,3.37,3.15,7.27.6,3,1.34,6.66,2.42,6.66s1.83-3.69,2.42-6.66c.78-3.9,1.45-7.27,3.15-7.27S22.17,21.4,23,25.3c.59,3,1.33,6.66,2.42,6.66s1.82-3.69,2.42-6.66c.78-3.9,1.45-7.27,3.15-7.27s2.37,3.37,3.15,7.27c.6,3,1.34,6.66,2.43,6.66s1.82-3.69,2.42-6.66c.78-3.9,1.45-7.27,3.15-7.27a.38.38,0,1,1,0,.75c-1.08,0-1.82,3.7-2.42,6.67C38.89,29.35,38.22,32.71,36.52,32.71Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_3408",
    "data-name": "Path 3408"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-mat-r-2",
    d: "M25.37,42.84a.75.75,0,0,1-.75-.75V8.65a.75.75,0,0,1,1.5,0V42.09A.74.74,0,0,1,25.37,42.84Z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatR);
export default __webpack_public_path__ + "static/media/mat-r.323e27ce23dbc40f323bc2fe4a147cce.svg";
export { ForwardRef as ReactComponent };